import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
// import EFVideo from '@/components/UI/EFVideo';
import NextImage from '@/components/NextImage';

const SCROLL_WIDTH = 14;

export default function L() {
    const { useLang, useState, gtm, useRouter } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/_YQbsiPE8to',
        cn: {
            SD: 'https://videos.ecoflow.com/72a93ed2912944e394c00c987ec02d51/eca86cd8599740649e24537d42a8e4f2-1fea741c33cd80836608e25bcdde5b24-fd.mp4',
            HD: 'https://videos.ecoflow.com/72a93ed2912944e394c00c987ec02d51/eca86cd8599740649e24537d42a8e4f2-530f22b100209d9680edc68de768d511-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/4827a210-1831b1bcf81-0004-9c91-e6d-40030.mp4',
        },
        kr: 'https://www.youtube.com/embed/j2M-lCE7GlM',
        ru: 'https://www.youtube.com/embed/kvOQkL1kx7M',
        cis: 'https://www.youtube.com/embed/kvOQkL1kx7M',
    };
    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 - Not Just a Battery',
            position,
        });
        setShowEFVideoModal(true);
    };

    useEffect(() => {
        let pageW = window.innerWidth - SCROLL_WIDTH;
        pageW = pageW > 2560 ? 2560 : pageW;

        AniContainer.create({
            asyncFromTo: [['.d2x-detail-L .video-box', { y: -(pageW * 0.07769) }, { y: 0 }, 1]],
            asyncTimeLine: [0],
            triggerElement: '.d2x-detail-L .video-box',
            triggerHook: 1,
            offset: 0,
            duration: '184%',
        });
    }, []);

    return (
        <div
            className={`d2x-detail-L ${css.d2xDetailL} GtmModuleData-section`}
            id="d2x-detail-L"
            data-section-id={'d2x-detail-L'}
            data-section-title={t('sec12_title')}
        >
            <div className="white-box">
                <div className="text-box">
                    <p className="slogan">{t('sec12_slogan')}</p>
                    <p className="title">{t('sec12_title')}</p>
                    <p className="desc">
                        {t.rich('sec12_desc', {
                            line: (text: any) => <span>{text}</span>,
                        })}
                    </p>
                    {/* <div className="watch-video-btn" onClick={() => playerVideo(t('sec1_title'))}>
                    {t('sec1_btn')}
                    <EFVideoPlayerBlack className="icon" />
                </div> */}
                </div>
            </div>
            <div className="ani-box">
                <div className="video-box">
                    <div className="video">
                        {/* <EFVideo className="video" autoPlay={true} sources={['/video/delta2max/detail/pc/11.webm', '/video/delta2max/detail/pc/11.mp4']} /> */}
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/3.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/3.jpg')}
                            alt={t('sec12_title')}
                            aria-label={t('sec12_title')}
                        />
                    </div>
                </div>
            </div>
            {/* <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            /> */}
        </div>
    );
}
